export enum DetailListStyle {
  RowHeight = '2.125rem',
  ColAmount = '1'
}

export interface DetailRow {
  key: string;
  value: string;
}